<template>
  <!-- 修改添加的弹窗 -->
  <div>
    <a-modal
      :title="modalTitle"
      :visible="visible"
      @ok="okFun"
      @cancel="closeFun"
      v-bind="this.$store.state.modalConfig"
    >
      <x-addEdit
        ref="addEdit"
        :itemLayout="$store.state.modal_ItemLayout"
        :formList="formList"
        :formKey="formKey"
        :addParam="addParam"
        :editParam="editParam"
        :detailParam="detailParam"
        :initReqHandle = 'initReqHandle'
        :isSubmitBtn="false"
      >
      <template slot="1" slot-scope="{formItem}">
          <a-form-item :label="formItem.label" required v-bind="$store.state.modal_ItemLayout">
            <a-checkbox v-decorator="formItem.props" default-checked></a-checkbox>
          </a-form-item>
        </template>
      </x-addEdit>
    </a-modal>
  </div>
</template>

<script>
import { findListItem, handleHttpMethod } from '@/utils/common';
import { fetchSelect } from '@/utils/mixins';
export default {
  name: 'industryQualificationsAdd',
  mixins: [fetchSelect],
  props: ['id'],
  components: { },
  data () {
    return {
      initReqHandle: false,
      modalTitle: '新增',
      visible: false,
      formList: [
        {
          label: '资质要求',
          inputType: 'select',
          options: [
          ],
          handle: '',
          placeholder: '请选择',
          props: ['certId', {
            rules: [{ required: true, message: '请选择资质要求' }]
          }]
        },
        {
          slot: '1',
          label: '必填项',
          inputType: 'input',
          props: ['isRequire', {
            rules: [{required: true, message: '请选择必填项'}]
          }]
        }
      ]

    };
  },
  created () {
    this.$get({
      url: '/local/qualify/cert/selectTree',
      params: { }
    }).then((res) => {
      this.formList[0].options = res.data;
    });
  },
  methods: {
    okFun () {
      this.$refs.addEdit.form.validateFields((err, values) => {
        let obj = {};
        obj.certId = values.certId;
        obj.isRequire = values.isRequire === undefined ? '1' : values.isRequire ? 1 : 0;
        obj.categoryIds = [this.id];
        this.submit(obj);
      });
      this.visible = false;
    },
    submit (obj) {
      this.$post({
        url: '/local/qualify/cert',
        params: {...obj}
      }).then((res) => {
        this.$emit('update');
      });
    },
    closeFun () {
      this.visible = false;
    },
    ResHandle (res) {
      this.closeFun();
      return res;
    },
    detailResHandle (res) {
      return res;
    },
    reqHandle (param) {
      return param;
    },
    addResHandle (res) {
      return res;
    },
    editResHandle (res) {
      return res;
    },
    addreqHandle (req) {
      let choseList = req.categoryIds;
      req.categoryIds = arr;
      if (this.$route.query.menuId) {
        req.parentId = this.$route.query.menuId;
      }
      return req;
    }
  }
};
</script>
<style lang="less" scoped>
</style>
